export const invoiceTypes = [
  {
    id: "Sale Invoice",
    name: "Sale Invoice",
  },
  {
    id: "Debit Note",
    name: "Debit Note",
  },
];